/**
 * `/merchandising/orders/new` — log a buyer's garment order (ADR-0039). The
 * lightweight intake counterpart of `/merchandising/styles/new`.
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { GarmentOrderComposerPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/merchandising/orders/new")({
  component: NewOrderRoute,
});

function NewOrderRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Merchandising", to: "/" },
        { label: "Orders", to: "/merchandising/orders" },
        { label: "New order" },
      ]}
      viewportClassName="!p-0"
      contentClassName="max-w-none"
    >
      <GarmentOrderComposerPage />
    </WorkspaceShell>
  );
}
